// removed by extract-text-webpack-plugin
module.exports = {"gridGutterWidth":"30px","content":"G5ec6ea Ga912d5 Gaf382d G1ae567","goustoOnDemandContainer":"G1b4814","button":"Gcf1741 Ge743c3 G143d95"};